<template>
  <div class="content">

    <!-- 基本信息 -->
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span style="font-weight: bolder">基本信息</span>
      </div>
      <el-descriptions :column="4" :contentStyle="{'font-size': '15px'}" :labelStyle="{'font-weight': 'bold','color':'#303133'}">
        <el-descriptions-item label="小程序用户Id">{{data.wxMpUserId}}</el-descriptions-item>
        <el-descriptions-item label="卡申请订单号">{{data.orderNum}}</el-descriptions-item>
        <el-descriptions-item label="应用场景">{{data.app}}</el-descriptions-item>
        <el-descriptions-item label="公司名称">{{data.company}}</el-descriptions-item>
        <el-descriptions-item label="申请电信卡数量">{{data.ctNum}}</el-descriptions-item>
        <el-descriptions-item label="申请移动卡数量">{{data.cmNum}}</el-descriptions-item>
        <el-descriptions-item label="申请联通卡数量">{{data.cuNum}}</el-descriptions-item>
        <el-descriptions-item label="申请卡总数量">{{data.totalNum}}</el-descriptions-item>
        <el-descriptions-item label="申请时间">{{data.createTime}}</el-descriptions-item>
        <el-descriptions-item label="申请状态">
            <el-tag v-if="data.status == '0'" type="warning">拒绝</el-tag>
            <el-tag v-else-if="data.status == '1'" type="warning">审核中</el-tag>
            <el-tag v-else-if="data.status == '2'" type="primary">已通过</el-tag>
            <el-tag v-else-if="data.status == '3'" type="primary">已寄出</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="发货状态">
          <el-tag v-if="data.outStatus == '1'" type="warning">未发货</el-tag>
          <el-tag v-else type="success">已发货</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="收货人">{{data.recipient}}</el-descriptions-item>
        <el-descriptions-item label="收货手机号">{{data.phone}}</el-descriptions-item>
        <el-descriptions-item label="发货地址">{{data.address}}</el-descriptions-item>
        <el-descriptions-item label="物流单号">{{data.outNum}}</el-descriptions-item>
        <el-descriptions-item label="物流公司">{{data.outCompany}}</el-descriptions-item>
        <el-descriptions-item label="发货人">{{data.outId}}</el-descriptions-item>
        <el-descriptions-item label="发货时间">{{data.outTime}}</el-descriptions-item>
        <el-descriptions-item label="快递费（元）">{{data.freightMoney}}</el-descriptions-item>
        <el-descriptions-item label="卡费（元）">{{data.cardMoney}}</el-descriptions-item>
        <el-descriptions-item label="订单金额（元）">{{data.payMoney}}</el-descriptions-item>
        <el-descriptions-item label="实际到账金额（元）">{{data.accountMoney}}</el-descriptions-item>
        <el-descriptions-item label="订单状态">
          <el-tag v-if="data.orderStatus == '1'" type="danger">未支付</el-tag>
          <el-tag v-else-if="data.orderStatus == '2'" type="success">已支付</el-tag>
          <el-tag v-else-if="data.orderStatus == '3'" type="primary">已到账</el-tag>
          <el-tag v-else-if="data.orderStatus == '4'" type="warning">已退款</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="支付方式">
          <el-tag v-if="data.payType == '1'" type="primary">H5</el-tag>
          <el-tag v-else-if="data.payType == '2'" type="primary">微信支付</el-tag>
          <el-tag v-else-if="data.payType == '3'" type="primary">余额支付</el-tag>
          <el-tag v-else-if="data.payType == '4'" type="primary">系统支付</el-tag>
          <el-tag v-else-if="data.payType == '5'" type="primary">支付宝支付</el-tag>
          <el-tag v-else-if="data.payType == '6'" type="primary">贝宝支付</el-tag>
          <el-tag v-else-if="data.payType == '7'" type="primary">佣金支付</el-tag>
          <el-tag v-else-if="data.payType == '8'" type="primary">小程序支付</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="支付时间">{{data.payTime}}</el-descriptions-item>
        <el-descriptions-item label="到账时间">{{data.paymentTime}}</el-descriptions-item>
        <el-descriptions-item label="备注">{{data.remark}}</el-descriptions-item>
      </el-descriptions>
    </el-card>


    <el-card class="box-card" v-if="checkPermi(['cardTrial:showOperateBox']) && data.orderStatus != '1'">
      <div slot="header" class="clearfix">
        <span style="font-weight: bolder">操作处理</span>
      </div>

      <!-- 客服审核 -->
      <div v-if="checkPermi(['cardTrial:audit'])" class="audit-block">
        <el-form ref="auditform" :model="auditform" :rules="auditRules" label-width="110px" class="form-class" >
          <el-row>
            <el-col :span="8">
              <el-form-item label="审核状态" prop="status" >
                <el-select v-model="auditform.status" filterable clearable placeholder="请选择审核状态" style="width:300px">
                  <el-option v-for="item in optStatus" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="备注" prop="remark" >
                <el-input type="text" placeholder="请输入备注" autocomplete="off" v-model="auditform.remark" style="width:300px"/>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item>
                <!-- 0 拒绝 1 审核中 2 已通过 3 已寄出  4 已完成 -->
                <el-button type="primary" size="medium" @click="auditSubmit('auditform')" v-if="data.status == '1'" >信息审核</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>

      <!-- 发快递 -->
      <div v-if="checkPermi(['cardTrial:express'])" class="courier-block">
        <el-form ref="expressForm" :model="expressForm" :rules="expressRules"  label-width="110px" class="form-class" >
          <el-row>
            <el-col :span="8">
              <el-form-item label="ICCID列表：" prop="iccids" >
                <el-input
                    v-model="expressForm.iccids"
                    type="textarea"
                    :placeholder="'以回车键分割ICCID，最多2000条数据'"
                    rows="6"
                    style="width:300px"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="快递公司" prop="courierName" >
                <el-input type="text" placeholder="请输入快递公司" v-model="expressForm.courierName" style="width:300px"/>
              </el-form-item>
              <el-form-item label="快递单号" prop="courierNum" style="margin-top: 66px">
                <el-input type="text" placeholder="请输入快递单号" autocomplete="off" v-model="expressForm.courierNum" style="width:300px"/>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item >
                <el-button type="primary" size="medium" @click="expressSubmit('expressForm')"  v-if="data.status == '2'">提交数据</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>

    </el-card>

    <el-tabs v-model="activeName" @tab-click="handleClick" v-if="data.orderStatus != '1'">
      <el-tab-pane label="卡列表" name="cardTrialCardList" v-if="checkPermi(['cardTrial:cardList'])"  >
        <cardTrialCardList ref="cardTrialCardListRef" :ordernum="this.orderNum"></cardTrialCardList>
      </el-tab-pane>
      <el-tab-pane label="操作记录" name="cardTrialOperationList" v-if="checkPermi(['cardTrial:operationList'])">
        <cardTrialOperationList ref="cardTrialOperationListRef" :ordernum="this.orderNum"></cardTrialOperationList>
      </el-tab-pane>
    </el-tabs>

  </div>
</template>
<script>
import {cardTrialAudit, cardTrialExpress, getCardTrial} from "@/api/api.js";//获取详情
import cardTrialCardList from "@/components/cardTrial/cardTrialCardList.vue";
import cardTrialOperationList from "@/components/cardTrial/cardTrialOperationList.vue";
export default {
  name:"cardTrialDetail",
  components: {
    cardTrialCardList,
    cardTrialOperationList,
  },
  data() {
    return {
      orderNum:'',
      data: {},
      form:{},
      rules: {
        outCompany: [
          { required: true, message: "快递公司不可为空", trigger: "blur" }
        ],
        outNum: [
          { required: true, message: "快递单号不可为空", trigger: "blur" }
        ],
        changeIccid:[
          { required: true, message: "新ICCID不可为空", trigger: "blur" }
        ]
      },
      expressForm:{},
      expressRules:{
        courierName:[
          { required: true, message: "请输入快递公司名称", trigger: "blur" }
        ],
        courierNum:[
          { required: true, message: "请输入快递单号", trigger: "blur" }
        ],
        iccids:[
          { required: true, message: "请输入关联卡号", trigger: "blur" }
        ],
      },
      auditform:{},
      auditRules:{
        status:[
          { required: true, message: "请选择审核状态", trigger: "blur" }
        ]
      },
      optStatus:[
        { value: 0, label: "拒绝" },
        { value: 2, label: "已通过" },
      ],
      activeName: "cardTrialCardList",
    };
  },
  computed: {},
  methods: {
    transferOrderStatus(status) {
      let obj = {
        1: "未发货",
        2: "已发货",
      };
      return obj[status];
    },
    // 初始化信息
    initData(){
      let params = {
        orderNum:this.orderNum
      }
      getCardTrial(params).then(res => {
        this.data = res.data.data;
        this.form = res.data.data;
        // this.data.outStatus = this.transferOrderStatus(this.data.outStatus);
      })
    },
    // 提交快递
    expressSubmit(formName){
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = {
            ...this.expressForm
          };
          params.orderNum = this.orderNum;
          cardTrialExpress(params).then(res=>{
            this.$notify({
                title: '成功',
                message: '已修改成功',
                type: 'success'
            });
            this.initData();
          })
        }
      })
    },
    // 提交审核
    auditSubmit(formName){
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = {
            ...this.auditform
          };
          params.orderNum = this.orderNum;
          cardTrialAudit(params).then(res=>{
            this.$notify({
              title: '成功',
              message: '已修改成功',
              type: 'success'
            });
            this.initData();
          })
        }
      })
    },
    handleClick(tab) {
      if (tab.name === "cardTrialCardList") {
        this.$refs.cardTrialCardListRef.initData();
      }else if(tab.name === "cardTrialOperationList"){
        this.$refs.cardTrialOperationListRef.initData();
      }
    },
  },
  created() {
    this.orderNum =  this.$route.params && this.$route.params.orderNum;
    this.initData();
  },
  mounted() {
    
  }
};
</script>
<style scoped>
.reg-img {
  max-width: 300px;
  max-height: 300px;
}
.el-form-item__content {
  color: #1890ff;
}
.form-class {
  margin-left: 50px;
  margin-top: 30px;
}
.courier-block {
  border: #d9e2ec solid 1px;
}
.audit-block {
  margin-top: 30px;
  border: #d9e2ec solid 1px;
}
.el-upload-list.el-upload-list--picture-card .el-upload-list__item {
  width: 146px !important;
  height: 146px !important;
  margin-right: 13px;
}
.el-upload-list.el-upload-list--picture-card .el-upload-list__item       .el-image {
  width: 146px;
  height: 146px;
  border-radius: 4px;
}
</style>
